import { colors, PieChartOption } from '@creditsights/styleguide-web';
import { CreditRiskLevel } from '../../../../models/RiskProducts';
import { CreditRiskLevelMetric } from '../../../../services/dtos/riskProducts/creditRiskLevels.dto';
import { WidgetMetricDto } from '../../../../services/dtos/riskProducts/widgetMetric.dto';
import { FONT_FAMILY, getColor, ACR_COLORS, getTooltipMarkerHtml } from '../../../../utils/chartUtils';

export const WIDGET_TITLE = 'Risk Summary';

export const getChartConfig = (
  data?: CreditRiskLevel[],
  selectedCreditRiskMetric?: CreditRiskLevelMetric,
  metricOptions?: WidgetMetricDto[],
  forDownload = false
): PieChartOption | undefined => {
  if (!selectedCreditRiskMetric || !data) {
    return undefined;
  }
  return {
    title: forDownload
      ? {
          text: `${WIDGET_TITLE} - ${metricOptions?.find((option) => option.id === selectedCreditRiskMetric)?.name}`,
          textStyle: {
            fontSize: 18,
            lineHeight: 28,
            fontWeight: 700,
            color: colors.tertiary1000,
            fontFamily: FONT_FAMILY,
          },
          subtext: '{a|Source: CreditSights Analytics, LLC.}',
          subtextStyle: {
            rich: {
              a: {
                fontSize: 10,
                color: colors.tertiary400,
                verticalAlign: 'bottom',
                padding: [0, 0, -260, 5],
              },
            },
          },
        }
      : undefined,
    animation: !forDownload,
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        return `
              ${getTooltipMarkerHtml(params.data.itemStyle.color ?? params.color)}
              <span>
                ${params.data.name}: ${params.data.value} Companies
              </span>
          `;
      },
      backgroundColor: colors.tertiary1000,
      borderColor: colors.tertiary1000,
      textStyle: {
        color: colors['white-color'],
        fontSize: 12,
        fontWeight: 400,
        fontStyle: 'normal',
        fontFamily: FONT_FAMILY,
        lineHeight: 12,
        height: 28,
      },
    },
    legend: {
      show: true,
      type: 'scroll',
      orient: 'vertical',
      right: 'right',
      top: 'center',
      height: '100%',
      itemWidth: 8,
      itemHeight: 8,
      borderRadius: 2,
      itemGap: 16,
      padding: [0, 10, 0, 0],
      itemStyle: {
        borderWidth: 0,
      },
    },
    series: [
      {
        type: 'pie',
        width: '74%',
        radius: ['61%', '82%'],
        center: ['52%', forDownload ? '52%' : '45%'],
        itemStyle: {
          borderColor: colors['white-color'],
          borderWidth: 2,
        },
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: data.map((creditRiskLevel) => ({
          value: creditRiskLevel.companyIds.length,
          name: creditRiskLevel.key,
          itemStyle: {
            color: selectedCreditRiskMetric === CreditRiskLevelMetric.ACR ? undefined : getColor(creditRiskLevel.key),
          },
        })),
        color: selectedCreditRiskMetric === CreditRiskLevelMetric.ACR ? ACR_COLORS : undefined,
        emphasis: {
          scaleSize: 5,
          itemStyle: {
            borderColor: colors['white-color'],
            borderWidth: 2,
            shadowColor: 'rgba(29, 43, 53, 0.2)',
            shadowBlur: 10,
          },
        },
      },
    ],
  };
};
